<div class="mat-page-container">
  <app-dashboard-review-card
    [dashboardDetails]="dashboardDetails"
  ></app-dashboard-review-card>
  <app-dashboard-review-details
    [dashboardDetails]="dashboardDetails"
  ></app-dashboard-review-details>
</div>
<app-footer></app-footer>
